import { render, staticRenderFns } from "./ECertificate.vue?vue&type=template&id=6945013a&scoped=true"
import script from "./ECertificate.vue?vue&type=script&lang=js"
export * from "./ECertificate.vue?vue&type=script&lang=js"
import style0 from "./ECertificate.vue?vue&type=style&index=0&id=6945013a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6945013a",
  null
  
)

export default component.exports